import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks'
import { selectRoomSession } from '../../../../../../../store/meetingSummary/roomSession'
import { openModal } from '../../../../../../../store/modal/modal'
import {
  DocumentConnectorActionButton,
  type DocumentConnectorActionItem,
} from '../../../../../../../components/DocumentConnector/DocumentConnectorActionButton'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../../../../../common/integrations'
import { useCurrentUserIntegrations } from '../../../../../../../views/Integration/useCurrentUserIntegrations'
import { useLastUsedDocumentConnector } from '../../../../../../../common/lastUsedDocumentConnector'

export const MeetingSummaryAgentDocumentButton: React.FC = () => {
  const dispatch = useAppDispatch()
  const roomSession = useAppSelector(selectRoomSession)
  const [lastUsedServiceId, recordLastUsedServiceId] = useLastUsedDocumentConnector()

  const { documentUploadSupportedIntegrations } = useCurrentUserIntegrations()

  if (documentUploadSupportedIntegrations.length === 0 || !roomSession) {
    return null
  }

  const items: DocumentConnectorActionItem[] = documentUploadSupportedIntegrations.map(({ serviceId }) => ({
    key: serviceId,
    serviceId,
    label: `Save to ${getIntegrationDisplayName(serviceId)}`,
  }))

  const handleSelect = (key: string) => {
    const serviceId = key as IntegrationServiceId
    recordLastUsedServiceId(serviceId)
    dispatch(openModal({ type: 'saveMeetingSummaryToDocumentConnector', serviceId }))
  }

  return (
    <DocumentConnectorActionButton
      items={items}
      primaryKey={lastUsedServiceId ?? undefined}
      onSelect={handleSelect}
      buttonClassName='px-2 py-1 button-medium'
      buttonVariant='header'
    />
  )
}
